import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HRComponent from "./HRComponent";
import { FULL_STACK } from "../FullStack/FSConstants";

function HRGrid(props) {
    const { isSmallScreen, course } = props;

    const settings = {
        className: "center",
        dots: true,
        centerMode: true,
        infinite: true,
        centerPadding: isSmallScreen ? "10px" : "50px",
        slidesToShow: isSmallScreen ? 1 : 2,
        speed: 500
    };
    return (
        <div className="slider-container" style={{ width: isSmallScreen ? "80%" : "96.5%", margin: "auto" }}>
            <Slider {...settings}>
                <div>
                    <HRComponent 
                        isSmallScreen={isSmallScreen}
                        company={course === FULL_STACK ? "HR Manager at UST Global" :"HR Manager at Mphasis"}
                        name={course === FULL_STACK ? "Ruchi Rastogi" :"Nilanjana Ghosh"}
                        content={course === FULL_STACK ? "We have just inducted PaperLive-trained candidates in our team, and we are satisfied with their project experience and hands-on knowledge. Unlike most of the other freshers, they had good foundational knowledge in React, Node.js, and cloud deployment, coupled with great problem-solving abilities. Their capability to learn and apply concepts in real-world situations and deliver from day one sets PaperLive-trained candidates apart." :"The students at PaperLive Learning are excellent. They have outstanding technical abilities and a rapid rate of learning new things. The speed with which they adopt and apply new concepts is impressive."}
                    />
                </div>
                <div>
                    <HRComponent
                        isSmallScreen={isSmallScreen}
                        company={course === FULL_STACK ? "HR Manager at Unisys" :"HR Manager at Hyland Software"}
                        name={course === FULL_STACK ? "Eshu K" :"Atul Raj"}
                        content={course === FULL_STACK ? "PaperLive Learning has provided us with a consistent supply of talented Full Stack Developers for our recruitment purposes. The individuals we interviewed possessed refined resumes, good GitHub portfolios, and were self-assured in tech conversations. Their exposure to practical case studies and mock interviews impressed us the most, as it simplified the recruitment process for us. We hope to recruit more talented individuals from PaperLive in the future." :"The students at PaperLive Learning possess a multitude of skills and knowledge. They're doing a fantastic job. We anticipate keeping up this encouraging trend and getting further assistance from PaperLive Learning in our recruitment efforts."}
                    />
                </div>
            </Slider>
        </div>
    );
}

export default HRGrid;
